import { firestoreAction } from "vuexfire";
import firebase from "@/firebase";
import db from "@/db";

const posts = db.collection("posts");

const state = {
  groupId: "", //the id of selected groupId
  lastGroupId: "",
  groupName: "", //the groupId code of selected groupId
  groupType: "",
  curGroup: {},
  posts: [], //the posts associated with the selected groupId
  replies: [], //the replies to a post
  newNotificaton: {}, //Newest Post
  searchingGroup: false,
  groupPreview: {},
  creatingGroup: false,
  changingImage: false,
  addReaction: false,
  loadedInitPosts: false,
};

const mutations = {
  // Sets the groupId selected by the user
  setGroupId(state, groupId) {
    state.lastGroupId = state.groupId;
    state.groupId = groupId;
  },

  setGroupName(state, groupName) {
    state.groupName = groupName;
  },

  setGroupType(state, groupType) {
    state.groupType = groupType;
  },

  setCurGroup(state, group) {
    state.curGroup = group;
  },

  removeReplies(state) {
    state.replies = [];
  },

  reversePosts(state) {
    state.posts.reverse();
  },

  setSearchGroup(state, isSearching) {
    state.searchingGroup = isSearching;
  },

  setGroupPreview(state, groupPreview) {
    state.groupPreview = groupPreview;
  },

  setCreateGroup(state, isCreating) {
    state.creatingGroup = isCreating;
  },

  setChangeImage(state, isChanging) {
    state.changingImage = isChanging;
  },

  setAddReaction(state, isAdding) {
    state.addReaction = isAdding;
  },

  setLoadedInit(state, isLoaded) {
    state.loadedInitPosts = isLoaded;
  },
};

const actions = {
  // Finished creating the post and adds it to firebase
  async createPost({ commit }, postInfo) {
    const result = posts.doc();
    const user = firebase.auth().currentUser;
    var post = postInfo.post;
    var recentPosts = postInfo.posts;
    var groupType = postInfo.type;
    var groupId = postInfo.id;
    const userSeen = {
      name: postInfo.user.firstName + " " + postInfo.user.lastName,
      profileImage: postInfo.user.profileImage,
      id: user.uid,
    };
    var hasSeen = [];
    hasSeen.push(userSeen);
    const id = "p" + result.id;
    post.user_id = user.uid;
    post.created_at = Date.now();
    var recentPost = {};
    if (
      groupType === "directMessages" &&
      postInfo.curGroup.notificationsEnabled
    ) {
      recentPost = {
        content: post.content,
        created_at: post.created_at,
        user_id: post.user_id,
      };
      var dm = firebase
        .functions()
        .httpsCallable("sendDirectMessageNotification");
      dm({
        token: postInfo.curGroup.token,
        name: postInfo.user.firstName + " " + postInfo.user.lastName,
        id: postInfo.curGroup.id,
        content: post.content,
      });
    } else {
      recentPost = {
        content: post.content,
        created_at: post.created_at,
        profileImage: post.profileImage,
        user_id: post.user_id,
        username: post.username,
      };
      var message = firebase.functions().httpsCallable("sendPostNotification");
      var type = "";
      switch (postInfo.curGroup.type) {
        case "courses":
          type = "course";
          break;
        case "groups":
          type = "group";
          break;
        case "faculties":
          type = "faculty";
          break;
        case "directMessages":
          type = "directMessage";
          break;
      }
      message({
        username: postInfo.user.firstName + " " + postInfo.user.lastName,
        id: postInfo.id,
        content: post.content,
        groupName: postInfo.groupName,
        userId: postInfo.user.id,
        type: type,
      });
    }

    // Check for files
    if (post.files) {
      recentPost.files = post.files;
    }

    // Check for reply
    if (post.replyContent) {
      recentPost.replyUsername = post.replyUsername;
      recentPost.replyContent = post.replyContent;
      if (post.replyFiles) {
        recentPost.replyFiles = post.replyFiles;
      }
      recentPost.parent_id = post.parent_id;
    }

    // Check for tags{
    if (post.atRanges) {
      if (post.atRanges.length > 0) {
        recentPost.atRanges = post.atRanges;
      }
    }
    recentPost.chat_id = groupId;
    try {
      posts.doc(id).set(recentPost);
    } catch (error) {
      console.error(error);
    }
    delete recentPost.chat_id;
    recentPost.id = id;
    recentPosts.push(recentPost);
    while (recentPosts.length > 25) {
      recentPosts.splice(0, 1);
    }
    var docRef = db.collection(groupType).doc(groupId);
    db.runTransaction((transaction) => {
      return transaction.get(docRef).then((doc) => {
        if (doc.exists) {
          let recent = doc.data().recentPosts ? doc.data().recentPosts : [];
          recent.push(recentPost);
          while (recent.length > 25) {
            recent.splice(0, 1);
          }
          var userInfo = {
            name: postInfo.user.firstName + " " + postInfo.user.lastName,
            id: postInfo.user.id,
            profileImage: postInfo.user.profileImage,
          };
          transaction.update(docRef, {
            recentPosts: recent,
            hasSeenLastPost: [userInfo],
          });
        }
      });
    });
    postInfo.curGroup.recentPosts = recentPosts;
    commit("setCurGroup", postInfo.curGroup);
  },

  async toggleClip(_, post) {
    var alreadyClipped = false;
    if (post.user_id === this.user.id) {
      return;
    }

    db.collection("users")
      .doc(this.user.id)
      .get()
      .then((doc) => {
        for (const clip in doc.data().clips) {
          if (doc.data().clips[clip] === post.id) {
            alreadyClipped = true;
          }
        }

        if (!alreadyClipped) {
          db.collection("posts")
            .doc(post.id)
            .update({
              clips: firebase.firestore.FieldValue.increment(1),
            });
          db.collection("users")
            .doc(this.user.id)
            .update({
              clips: firebase.firestore.FieldValue.arrayUnion(post.id),
            });
          db.collection("users")
            .doc(post.user_id)
            .update({
              totalClips: firebase.firestore.FieldValue.increment(1),
            });
        } else {
          db.collection("posts")
            .doc(post.id)
            .update({
              clips: firebase.firestore.FieldValue.increment(-1),
            });
          db.collection("users")
            .doc(this.user.id)
            .update({
              clips: firebase.firestore.FieldValue.arrayRemove(post.id),
            });
          db.collection("users")
            .doc(post.user_id)
            .update({
              totalClips: firebase.firestore.FieldValue.increment(-1),
            });
        }
      });
  },

  //Binds replies to the firebase collection of posts that are repling to a given post
  initReplies: firestoreAction(({ bindFirestoreRef }, originalPost_id) => {
    bindFirestoreRef(
      "replies",
      db
        .collection("posts")
        .where("originalPost_id", "==", originalPost_id)
        .orderBy("created_at", "asc")
    );
  }),

  //Gets the newest post from that groupId
  newestNotification: firestoreAction(({ bindFirestoreRef }, group_ids) => {
    bindFirestoreRef(
      "newNotification",
      db
        .collection("posts")
        .where("chat_id", "in", group_ids)
        .orderBy("created_at", "desc")
        .limit(1)
    );
  }),

  unbindPosts: firestoreAction(({ unbindFirestoreRef }) => {
    unbindFirestoreRef("newNotification");
  }),

  unsubscribeFromTopic(_, data) {
    const groupId = data.groupId;
    const token = data.token;
    if (groupId !== null) {
      var unsub = firebase.functions().httpsCallable("unsubscribeFromTopic");
      unsub({ tokens: [token], groupId: groupId });
    }
  },

  async subscribeToTopic(_, data) {
    const groupId = data.groupId;
    const token = data.user.iOSToken;
    const user = data.user;

    for (const course in user.courses) {
      if (
        !user.courses[course].notificationsEnabled &&
        user.courses[course].id === groupId
      ) {
        return;
      }
    }

    for (const faculty in user.faculties) {
      if (
        !user.faculties[faculty].notificationsEnabled &&
        user.faculties[faculty].id === groupId
      ) {
        return;
      }
    }

    for (const group in user.groups) {
      if (
        !user.groups[group].notificationsEnabled &&
        user.groups[group].id === groupId
      ) {
        return;
      }
    }

    var subscribeToTopic = firebase
      .functions()
      .httpsCallable("subscribeToTopic");
    subscribeToTopic({
      tokens: [token],
      groupId: groupId,
    });
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
